import React from "react";
import styles from "./Favorite.scss";
import { getIconUrl } from "../../services/asset";
import { AdListFavoriteDataI } from "../../typings/routesTypes";

export interface FavoriteProps {
  handleFavorite: () => void;
  ad: AdListFavoriteDataI;
}

const Favorite = (props: FavoriteProps): JSX.Element => {
  const { handleFavorite, ad } = props;
  return (
    <span
      role="button"
      tabIndex={0}
      onClick={ad && handleFavorite}
      className={styles.favoriteButton}
    >
      <img
        alt={"Spremi"}
        src={getIconUrl(
          ad && ad.isFavorite ? "favorite_hover.svg" : "favorite.svg"
        )}
      />
      <span className={styles.text}>
        {"Spremi"}
      </span>
    </span>
  );
}

export default Favorite;



// WEBPACK FOOTER //
// ./src/components/Favorite/Favorite.tsx